import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BindUserModal } from './BindUserModal';
import { RequestFileImage } from './RequestFileImage';
import { requestsActions } from '../../../actions';
import { usePrevious } from '../hooks';

export function BindUserForRequestFileModal(props) {
    const { request, requestFile, onClose } = props;
    const { getting, hasErrors } = useSelector((state) => state.requests);
    const gettingPrevious = usePrevious(getting);
    const dispatch = useDispatch();

    useEffect(() => {
        //console.log('use effect', getting, gettingPrevious, !!requestFile, hasErrors);
        if (requestFile && gettingPrevious && !getting) {
            //момент завершения действия по обращению к АПИ сохранения привязки
            console.log('binding ended', hasErrors);
            if (!hasErrors) {
                onClose();
            }
        }
    }, [getting, gettingPrevious, requestFile, hasErrors, onClose]);

    const handleBindUserClick = useCallback(
        (userId) => {
            dispatch(requestsActions.bindFileToUser({ userId, fileId: requestFile.id }));
        },
        [dispatch, requestFile]
    );

    return (
        <BindUserModal
            request={request}
            show={!!requestFile}
            userId={requestFile && requestFile.userId}
            inProgress={getting}
            onCancel={onClose}
            onBind={handleBindUserClick}
        >
            {requestFile && (
                <div className="mb-3 d-flex">
                    <div className="mr-3">
                        <RequestFileImage requestFile={requestFile} />
                    </div>
                    <div>{requestFile.filename}</div>
                </div>
            )}
        </BindUserModal>
    );
}
